import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if the current page is a legacy page (non-React)
 * @returns boolean - true if the current page is a legacy page
 */
export function isLegacyPage(): boolean {
  if (typeof window === 'undefined') return false;

  // Check if the URL ends with .html or if we're in a legacy context
  return (
    window.location.pathname.endsWith('.html') ||
    // Add any other legacy page indicators here
    document.documentElement.hasAttribute('data-legacy-page')
  );
}

export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Increments a semantic version string (e.g. '1.0' -> '1.1', '1.2.9' -> '1.2.10').
 * If version is missing or invalid, returns '1.0'.
 * Only increments the PATCH (last) digit.
 */
export function autoIncrementSemanticVersion(version: string): string {
  if (!version || typeof version !== 'string') return '1.0';
  const parts = version.split('.').map(Number);
  if (parts.some(isNaN) || parts.length === 0) return '1.0';
  // Ensure at least 2 digits (major.minor)
  while (parts.length < 2) parts.push(0);
  // Increment last digit (patch)
  parts[parts.length - 1]++;
  return parts.join('.');
}

